<template>
<!-- 文化活动详情 -->
    <div class="activity_detail_warp">
        <BaseDetail ref="baseDetail" >
            <template slot="cont" scope="{info}">
                <div class="cont_warp" >
                    <el-image class="cont_top_img" :src="info.cover" ></el-image>
                    <div class="top_info">
                        <div class="cont_top_title">{{info.title}}</div>
                        <div class="behavior_box">
                            <div>浏览 0 </div>
                            <div class="behavior_list">
                                <div class="behavior_item" @click="operation(0)">
                                    <svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
                                    {{operCount.dzs}}
                                </div>
                                <div class="behavior_item" @click="operation(1)">
                                     <i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''"  />
                                    {{operCount.scs}}
                                </div>
                                <!-- <div class="behavior_item">
                                    <i class="el-icon-share item_icon"/> 分享
                                </div> -->
                            </div>
                            <el-button v-if="info.activityStatus" @click="operation(2)" type="primary">{{info.statusName}}</el-button>
                            <el-button v-else type="info">{{info.statusName}}</el-button>
                        </div>
                        <div class="top_line">时间：{{formatDate(info.startTime)}} ~ {{formatDate(info.endTime)}}</div>
                        <div class="top_line">名额：<span class="maxcount">{{info.maxcount+'人' || '不限人数'}}</span></div>
                        <div class="top_line">地址：{{info.addr}}</div>
                        <div class="activity_content" v-html="info.content"></div>
                    </div>
                </div>
            </template>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { formatDate } from "@u/index.js";
import { post } from '@u/request'
import { mapGetters } from 'vuex'

const urls = [
    {url: 'praise',message: '点赞成功！'},
    {url: 'collect',message: '收藏成功！'},
    {url: 'readeractivity',message: '报名成功！'},
]

export default {
    name: 'activityDetail',
    components: {
        BaseDetail
    },
    data() {
        return {
            operCount: {}
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
	watch: {
	    'readerId'(value){
		    this.operinfo()
	    }
	},
    methods: {
        formatDate(date) {
            return formatDate(date)
        },
        async operation(index) {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (index == 0 && this.operCount.ydz) {
                this.$message.success('已经点赞啦！');
                return;
            }
            if (index == 1 && this.operCount.ysc) {
                this.$message.success('已经收藏啦！');
                return;
            }
            if (index == 2 && this.operCount.ybm) {
                this.$message.success('已经报名啦！');
                return;
            }
            const currentUrl = urls[index]
            const params = {
                readerId: this.readerId,
                activityId: this.contentId
            }
            const { data } = await post(`resource/${currentUrl.url}/add`, params)
            this.$message.success(currentUrl.message)
            this.operinfo()
        },
        async operinfo() {
            const params = {
                readerId: this.readerId,
                activityId: this.contentId
            }
            const { data } = await post('resource/showapi/operinfo', params);
            this.operCount = data;
        }

    },
    mounted() {
        this.$refs.baseDetail.videoLoad('activity')
        this.$refs.baseDetail.loadCommentList('activityId')
        this.operinfo()
    }
}
</script>

<style scoped lang="scss">
.activity_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .cont_warp {
        .cont_top_img {
            width: 100%;
            height: 392px;
            border-radius: 5px 5px 0 0;
        }
     
        .top_info {
            padding: 19px 30px 35px 30px;
            color: #656567;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #000;
        }
        .top_line {
            padding-top: 16px;
        }
        .maxcount {
            color: #ff9c00;
        }
        .activity_content {
            margin-top: 50px;
			overflow: hidden;
			::v-deep {
				img {
					width: 100%;
				}
			}
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-right: auto;
            margin-left: 20px;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
    }
    .active_icon {
        color: #a80000;
    }
}
</style>